import { FC } from 'react';
import { useTheme } from 'styled-components';

import { ScGameItemPlug, ScGameItemPlugProps } from '../styled';

export const GameItemPlug: FC<ScGameItemPlugProps> = (props) => {
  const { logoMin: LogoMin } = useTheme();
  return (
    <ScGameItemPlug {...props}>
      <div className="logo">
        <LogoMin />
      </div>
    </ScGameItemPlug>
  );
};
